import { render, staticRenderFns } from "./ClosingReasonsTotal.vue?vue&type=template&id=48562a9a&scoped=true&"
import script from "./ClosingReasonsTotal.vue?vue&type=script&lang=js&"
export * from "./ClosingReasonsTotal.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReasonsTotal.vue?vue&type=style&index=0&id=48562a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48562a9a",
  null
  
)

export default component.exports